import { useCallback, useState } from 'react'
import type { ClaudeSession } from '@/features/events/conversation/state/types'
import { buildSessionArchivePayload, commandClient } from '../api'

interface UseArchiveSessionReturn {
  readonly archiveSession: (session: ClaudeSession) => Promise<boolean>
  readonly isSubmitting: boolean
}

export function useArchiveSession(): UseArchiveSessionReturn {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const archiveSession = useCallback(async (session: ClaudeSession): Promise<boolean> => {
    setIsSubmitting(true)

    try {
      const payload = buildSessionArchivePayload(session)
      const result = await commandClient.submit(payload)

      if (!result.success) {
        throw new Error(result.message)
      }

      return true
    } finally {
      setIsSubmitting(false)
    }
  }, [])

  return { archiveSession, isSubmitting }
}
